// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2254D","label":"styles_label__S-YGM"};